<template>
    <div id="leads-page">
        <ClientFormModal ref="modals" @client-created="onClientCreated" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <loader v-if="is('loading')"></loader>
                    <h1>{{ t('clients-leads-title') }}</h1>
                    <div>
                        <filter-bar
                            ref="filterBar"
                            :filters="extraFilters"
                            :show-labels="true"
                            @changed="updateFilters"
                            :has-branch-filter="canFilterPerBranch"
                        />
                        <div class="clearfix"></div>
                    </div>
                    <div class="clearfix" v-if="!is('loading')">
                        <grid
                            source="place/leads"
                            :filters="filters"
                            @loaded="updateTotal"
                            v-show="stats.totalClients > 0"
                        >
                            <template v-slot:grid-actions>
                                <div>
                                    <KvButton
                                        class="btn btn-success"
                                        @click="openCreateClient"
                                        >{{ t('clients-leads-add') }}</KvButton
                                    >
                                </div>
                            </template>
                            <template v-slot:rows="grid">
                                <thead>
                                    <tr>
                                        <grid-th
                                            :grid="grid"
                                            :sortable="true"
                                            attr="name"
                                            >{{ t('clients-columns-name') }}</grid-th
                                        >
                                        <grid-th
                                            :grid="grid"
                                            :sortable="true"
                                            attr="whatsapp"
                                            >{{ t('clients-columns-phone') }}</grid-th
                                        >
                                        <grid-th
                                            :grid="grid"
                                            :sortable="true"
                                            attr="email"
                                            >{{ t('clients-columns-email') }}</grid-th
                                        >
                                        <grid-th
                                            :grid="grid"
                                            :sortable="true"
                                            attr="birthdate"
                                            class="col-center"
                                            >{{ t('clients-columns-birthday') }}</grid-th
                                        >
                                        <grid-th
                                            :grid="grid"
                                            :sortable="true"
                                            attr="created_at"
                                            >{{ t('date') }}</grid-th
                                        >
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        style="cursor: pointer"
                                        v-for="client in grid.data"
                                        :key="client.clients_id"
                                        @click="
                                            $router.push(
                                                'client/' + client.clients_id,
                                            )
                                        "
                                    >
                                        <td style="min-width: 250px">
                                            {{ client.first_name }}
                                            {{ client.last_name }}
                                        </td>
                                        <td style="min-width: 160px">
                                            <btn-whatsapp
                                                :number="client.whatsapp"
                                            ></btn-whatsapp>
                                            {{ formatPhone(client.whatsapp) }}
                                        </td>
                                        <td style="min-width: 220px">
                                            {{ client.email }}
                                        </td>
                                        <td
                                            style="min-width: 160px"
                                            class="col-center"
                                        >
                                            <template v-if="client.birthdate">
                                                <human-date
                                                    :date="client.birthdate"
                                                    :format="t('dates-format_date')"
                                                />
                                                ({{
                                                    calculateAge(
                                                        client.birthdate,
                                                    )
                                                }}
                                                {{ t('clients-years_old') }})
                                            </template>
                                            <span v-else>{{ t('clients-not_informed') }}</span>
                                        </td>
                                        <td
                                            style="min-width: 220px"
                                            class="col-center"
                                        >
                                            <human-date
                                                v-if="client.created_at"
                                                :date="client.created_at"
                                                :format="t('dates-format_day_month_long')"
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-slot:list="grid">
                                <div
                                    class="item"
                                    v-for="client in grid.data"
                                    :key="client.clients_id"
                                >
                                    <span class="info title">
                                        {{ client.first_name }}
                                        {{ client.last_name }}
                                    </span>
                                    <span class="info">
                                        <span class="pull-left"
                                            >{{ formatPhone(client.whatsapp) }}
                                        </span>
                                        <btn-whatsapp
                                            :number="client.whatsapp"
                                        ></btn-whatsapp>
                                    </span>
                                    <div class="clear"></div>
                                    <span class="info">
                                        {{ client.email }}
                                    </span>
                                    <button
                                        class="btn btn-sm btn-primary"
                                        @click="
                                            $router.push(
                                                'client/' + client.clients_id,
                                            )
                                        "
                                    >
                                        {{ t('clients-details') }}
                                    </button>
                                </div>
                            </template>
                        </grid>
                    </div>
                    <div
                        class="clearfix"
                        v-if="is('loaded') && stats.totalClients === 0"
                    >
                        <div class="box">
                            <h1>{{ t('clients-leads-title') }}</h1>
                            <h2>{{ t('clients-leads-no_leads_found') }}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import keviApi from "../keviApi.js";
import HumanDate from "../components/human-date/human-date";
import ClientFormModal from "./components/client/client-form-modal.vue";
import KvButton from "@/components/form/kv-button.vue";
import phoneMixin from "../mixins/phone-mixin";
export default {
    mixins: [phoneMixin],
    components: {
        HumanDate,
        ClientFormModal,
        KvButton,
    },
    data: function () {
        return {
            state: "loading",
            stats: {
                dataFilledRate: 0,
                totalClients: 0,
                totalWithData: 0,
            },
            filters: {},
            extraFilters: [],
        };
    },
    mounted: function () {
        document.getElementsByTagName("title")[0].innerText =
            this.t('clients-leads-page_title');
        const filterBar = this.$refs.filterBar;
        filterBar.addFilter("period");
        if (this.$module("segments")) {
            let options = keviApi.getOptions("segments");
            this.$http(options).then((response) => {
                let segments = response.body;
                this.extraFitlers.push({
                    component: "checkbox",
                    label: this.$root.t('filter_bar-client_segments'),
                    name: "client-segments",
                    options: {
                        options: segments.map((seg) => ({
                            value: seg.id,
                            label: seg.name,
                        })),
                        icon: "ui-users-01",
                    },
                    removable: true,
                });
            });
        }
    },
    computed: {
        place() {
            return this.$store.state.place;
        },
        user() {
            return this.$store.state.user;
        },
        canFilterPerBranch() {
            return !!this.user.permissions["clients"]["options"][
                "global_access"
            ];
        },
    },
    methods: {
        openCreateClient() {
            this.$refs.modals.openCreateClient();
        },
        onClientCreated(client) {
            if (client && client.id) {
                this.$router.push('/client/' + client.id);
            }
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        is: function (state) {
            return this.state === state;
        },
        setState: function (state) {
            this.state = state;
        },
        updateFilters: function (filters) {
            this.setState("ready");
            this.filters = filters;
        },
        updateTotal(event) {
            this.stats.totalClients = event.total;
            this.setState("loaded");
        },
        calculateAge: function (birthday) {
            birthday = new Date(birthday);
            let ageDifMs = Date.now() - birthday.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },
    },
};
</script>
